(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.currentScript && document.currentScript.parentElement;
    var tracks = document.querySelectorAll('.brand-collection-grid__track[data-track]');

    tracks.forEach(function (track) {
      if (window.matchMedia('(max-width: 700px)').matches) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var viewport = track.parentElement;
      var pxPerSec = 18;
      var offset = 0;
      var lastTs = 0;
      var paused = false;
      var halfWidth = 0;

      function measure() {
        halfWidth = track.scrollWidth / 2;
      }
      measure();
      window.addEventListener('resize', measure);

      function frame(ts) {
        if (lastTs && !paused) {
          var dt = (ts - lastTs) / 1000;
          offset += pxPerSec * dt;
          if (offset >= halfWidth) offset -= halfWidth;
          track.style.transform = 'translateX(' + (-offset) + 'px)';
        }
        lastTs = ts;
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);

      viewport.addEventListener('mouseenter', function () { paused = true; });
      viewport.addEventListener('mouseleave', function () { paused = false; });
      viewport.addEventListener('focusin', function () { paused = true; });
      viewport.addEventListener('focusout', function () { paused = false; });

      var prev = viewport.querySelector('[data-nav="prev"]');
      var next = viewport.querySelector('[data-nav="next"]');
      function step(direction) {
        var firstItem = track.querySelector('.brand-collection-grid__item');
        var col = firstItem ? firstItem.getBoundingClientRect().width : 0;
        offset += direction * col;
        if (offset < 0) offset += halfWidth;
        if (offset >= halfWidth) offset -= halfWidth;
        track.style.transition = 'transform 0.4s ease';
        track.style.transform = 'translateX(' + (-offset) + 'px)';
        setTimeout(function () { track.style.transition = ''; }, 420);
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-book-band"]) return;
  try {
    
  class FloatingBookBand extends HTMLElement {
    constructor() {
      super();
      this.threshold = parseInt(this.getAttribute('data-scroll-threshold') || '50', 10);
      this.anchorSelector = this.getAttribute('data-anchor-selector') || 'footer';
      this.onScroll = this.onScroll.bind(this);
      this.update = this.update.bind(this);
      this.rafId = 0;
      this.footer = null;
      this.footerObserver = null;
    }

    connectedCallback() {
      const nodes = document.querySelectorAll(this.anchorSelector);
      this.footer = nodes.length ? nodes[nodes.length - 1] : null;

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('touchmove', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      window.addEventListener('pageshow', this.onScroll);

      if (this.footer && 'ResizeObserver' in window) {
        this.footerObserver = new ResizeObserver(this.onScroll);
        this.footerObserver.observe(this.footer);
      }

      this.update();
      for (const delay of [100, 500, 1500]) setTimeout(this.onScroll, delay);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('touchmove', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('pageshow', this.onScroll);
      if (this.footerObserver) this.footerObserver.disconnect();
      if (this.rafId) cancelAnimationFrame(this.rafId);
    }

    getScrollY() {
      return window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    updateVisibility() {
      if (this.getScrollY() > this.threshold) {
        this.classList.add('is-visible');
      } else {
        this.classList.remove('is-visible');
      }
    }

    onScroll() {
      if (this.rafId) return;
      this.rafId = requestAnimationFrame(this.update);
    }

    update() {
      this.rafId = 0;
      this.updateVisibility();
      this.position();
    }

    // Park above the footer only when the footer actually fits in the viewport.
    // Previously this switched to position:absolute, which pinned the band to a
    // document coordinate; on phones the footer is taller than the viewport, so
    // that coordinate had already scrolled off the top and the band vanished.
    position() {
      if (!this.footer) return;

      // Use the LAYOUT viewport, not window.innerHeight. position:fixed resolves
      // against clientHeight; on iOS innerHeight grows as the toolbars collapse,
      // which desynced the maths and pushed the band off-screen.
      const vh = document.documentElement.clientHeight || window.innerHeight;
      const height = this.offsetHeight;
      const base = parseFloat(getComputedStyle(this).getPropertyValue('--fbb-base-bottom')) || 40;
      const gap = 16;
      const minTop = 16;

      // Read live every frame: content above the footer lazy-loads and moves it.
      const rect = this.footer.getBoundingClientRect();
      const canPark = (rect.height + gap + height + minTop) <= vh;

      let bottom = base;
      if (canPark && rect.top < vh) {
        bottom = Math.max(base, vh - rect.top + gap);
      }

      // Hard clamp: the band must never be pushed off the top of the screen.
      // iOS Safari grows window.innerHeight as the toolbars collapse mid-scroll,
      // which can flip canPark true after rect.top has already gone negative;
      // without this clamp that computes a huge bottom offset and the band
      // disappears upward. Emulators do not reproduce it (fixed viewport).
      const maxBottom = vh - height - minTop;
      if (bottom > maxBottom) bottom = Math.max(base, maxBottom);

      this.style.bottom = bottom + 'px';

      // Deliberately NOT emitting an 'is-anchored' class. Older cached copies of
      // sixsix-overrides.css map that class to position:absolute, which combined
      // with a bottom-only offset anchors the band to the document origin and
      // throws it off-screen. Position is now driven entirely by `bottom` while
      // the element stays position:fixed.
      this.classList.remove('is-anchored');
    }
  }

  if (!customElements.get('floating-book-band')) {
    customElements.define('floating-book-band', FloatingBookBand);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-split"] && !Shopify.designMode) return;
  try {
    
  // Wordmark now uses pure CSS position: sticky — no JS scroll listener needed.
  // Update the --wm-half CSS variable once the image has loaded so release anchoring
  // stays precise across viewport sizes.
  (function () {
    var wm = document.querySelector('.hero-split__wordmark');
    if (!wm) return;
    function setHalf() {
      if (!wm.offsetHeight) return;
      wm.style.setProperty('--wm-half', (wm.offsetHeight / 2) + 'px');
    }
    if (wm.complete) {
      setHalf();
    } else {
      wm.addEventListener('load', setHalf, { once: true });
    }
    window.addEventListener('resize', setHalf, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
